import { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FolderTree = ({ folders, selectedFolder, onFolderSelect }) => {
  const [expandedFolders, setExpandedFolders] = useState(['root']);

  const toggleFolder = (folderId) => {
    setExpandedFolders(prev =>
      prev?.includes(folderId)
        ? prev?.filter(id => id !== folderId)
        : [...prev, folderId]
    );
  };

  const renderFolder = (folder, level = 0) => {
    const isExpanded = expandedFolders?.includes(folder?.id);
    const isSelected = selectedFolder?.id === folder?.id;
    const hasChildren = folder?.children && folder?.children?.length > 0;

    return (
      <div key={folder?.id}>
        <div
          className={`flex items-center gap-2 px-3 py-2 rounded-md cursor-pointer transition-all duration-150 ${
            isSelected
              ? 'bg-primary/10 text-primary' :'text-foreground hover:bg-accent/10'
          }`}
          style={{ paddingLeft: `${level * 16 + 12}px` }}
          onClick={() => {
            if (hasChildren) {
              toggleFolder(folder?.id);
            }
            onFolderSelect(folder);
          }}
        >
          {hasChildren && (
            <Icon
              name={isExpanded ? 'ChevronDown' : 'ChevronRight'}
              size={16}
              className="flex-shrink-0"
            />
          )}
          {!hasChildren && <div className="w-4" />}
          <Icon
            name={folder?.icon}
            size={18}
            className="flex-shrink-0"
            color={isSelected ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
          />
          <span className="text-sm font-medium truncate">{folder?.name}</span>
          {folder?.count > 0 && (
            <span className="ml-auto text-xs text-muted-foreground bg-muted px-2 py-0.5 rounded-full">
              {folder?.count}
            </span>
          )}
        </div>
        {hasChildren && isExpanded && (
          <div>
            {folder?.children?.map(child => renderFolder(child, level + 1))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="h-full overflow-y-auto custom-scrollbar">
      <div className="p-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-sm font-semibold text-foreground">Folders</h3>
          <button
            className="p-1 rounded-md hover:bg-accent/10 transition-colors"
            aria-label="Add new folder"
          >
            <Icon name="FolderPlus" size={18} color="var(--color-muted-foreground)" />
          </button>
        </div>
        <div className="space-y-1">
          {folders?.map(folder => renderFolder(folder))}
        </div>
      </div>
    </div>
  );
};

export default FolderTree;